module.exports = __webpack_public_path__ + "media/images/benefits_background-33fe930cafb9b5d6df3a0c2c9ef7f327.png";